import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Placeholder from 'flarum/common/components/Placeholder';
import NwcTrackerItem from './NwcTrackerItem';

export const PAGE_SIZE = 20;

/**
 * Newest-first feed of tracked authors' posts with load-more pagination.
 */
export default class NwcTrackerFeed extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    this.posts = [];
    this.loading = false;
    this.moreResults = false;
    this.error = false;

    this.load(0);
  }

  load(offset) {
    this.loading = true;
    this.error = false;

    return app.store
      // Default includes (user, discussion and, when flarum/tags is enabled,
      // discussion.tags) are set by the backend controller.
      .find('nwc-tracker', { page: { offset, limit: PAGE_SIZE } })
      .then((results) => {
        this.posts.push(...results);
        const links = (results.payload && results.payload.links) || {};
        this.moreResults = !!links.next;
      })
      .catch(() => {
        this.error = true;
      })
      .finally(() => {
        this.loading = false;
        m.redraw();
      });
  }

  loadMore() {
    this.load(this.posts.length);
  }

  view() {
    let footer = null;

    if (this.loading) {
      footer = <LoadingIndicator />;
    } else if (this.error) {
      footer = <Placeholder text={app.translator.trans('mnm-nwc-tracker.forum.feed.error')} />;
    } else if (!this.posts.length) {
      footer = <Placeholder text={app.translator.trans('mnm-nwc-tracker.forum.feed.empty')} />;
    } else if (this.moreResults) {
      footer = (
        <Button className="Button NwcTracker-loadMore" onclick={this.loadMore.bind(this)}>
          {app.translator.trans('mnm-nwc-tracker.forum.feed.load_more')}
        </Button>
      );
    }

    return (
      <div className="NwcTracker">
        <div className="NwcTracker-header">
          <h2 className="NwcTracker-title">{app.translator.trans('mnm-nwc-tracker.forum.feed.title')}</h2>
          <p className="NwcTracker-subtitle">{app.translator.trans('mnm-nwc-tracker.forum.feed.subtitle')}</p>
        </div>
        <ul className="NwcTracker-list">
          {this.posts.map((post) => (
            <li key={post.id()} data-id={post.id()}>
              <NwcTrackerItem post={post} />
            </li>
          ))}
        </ul>
        <div className="NwcTracker-footer">{footer}</div>
      </div>
    );
  }
}
